import { render, staticRenderFns } from "./KnStudentAccountStatus.vue?vue&type=template&id=408f0594"
import script from "../KnStudentAccountStatus/KnStudentAccountStatus.js?vue&type=script&lang=js&external"
export * from "../KnStudentAccountStatus/KnStudentAccountStatus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports